import subscribeToPlaybackApiResponse from './Subscribers/subscribeToPlaybackApiResponse';
import subscribeToConcurrencyApiResponse from './Subscribers/subscribeToConcurrencyApiResponse';

const connectConcurrencySubscriptions = middleware => [
    subscribeToPlaybackApiResponse(
        middleware.apiServices.playback.response$,
        middleware.state.stores.concurrency
    ),
    subscribeToConcurrencyApiResponse(
        middleware.apiServices.concurrency.response$,
        middleware.state.stores.concurrency
    ),
];


export default connectConcurrencySubscriptions;
